import { render, staticRenderFns } from "./ExchangeRateForm.vue?vue&type=template&id=9230ab1a"
import script from "./ExchangeRateForm.vue?vue&type=script&lang=ts"
export * from "./ExchangeRateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports